var render = function render(_c,_vm){return _c('div',{staticClass:"form-group"},[_c('label',{staticClass:"text-bold-600",staticStyle:{"display":"block"}},[_vm._v(" ")]),_c('btn',{class:_vm.data.staticClass,attrs:{"disabled":_vm.props.disabled,"readonly":_vm.props.readonly},on:{"click":function($event){_vm.listeners.click && _vm.listeners.click()}}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }